import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 図面情報表示ダイアログ
 * CADAPIに計算してもらった結果を表示する
 */
class PlanAreaInfo extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // 情報をGET
    const data = marietta.webcad.WebCADGlobal.webcad2Dmanager.areaData;
    const id = 'dialogPlanAreaInfo';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '間取り情報'; break;
      default: title = 'Plan Information'; break;
    }

    let contents = '<div class="dialogPlanAreaTable menseki">\n';
    contents += '<table>\n';
    contents += '<tbody>\n';
    contents += '<tr>\n';
    contents += '<th class="summary"><span class="jp">総床面積</span><span class="en">Total Floor Area</span></th>\n';
    contents += `<td class="summary"><span class="jp">${data.floorSpace}㎡</span><span class="en">${data.floorSpace}㎡</span></td>\n`;
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<th><span class="jp">1階床面積</span><span class="en">1F Floor Area</span></th>\n';
    contents += `<td><span class="jp">${data.floor1Space}㎡</span><span class="en">${data.floor1Space}㎡</span></td>\n`;
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<th><span class="jp">2階床面積</span><span class="en">2F Floor Area</span></th>\n';
    contents += `<td><span class="jp">${data.floor2Space}㎡</span><span class="en">${data.floor2Space}㎡</span></td>\n`;
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<th><span class="jp">3階床面積</span><span class="en">3F Floor Area</span></th>\n';
    contents += `<td><span class="jp">${data.floor3Space}㎡</span><span class="en">${data.floor3Space}㎡</span></td>\n`;
    contents += '</tr>\n';
    contents += '</tbody>\n';
    contents += '</table>\n';
    contents += '</div>\n';

    const footer = '<button id="btnClose"><span class="jp">閉じる</span><span class="en">Close</span></button>';

    this.createDialog(id, title, contents, footer);

    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });
  }
}
export default PlanAreaInfo;
